<template>

    <ul class="pagination" role="navigation">
        <li class="page-item disabled" aria-disabled="true" aria-label="« Previous">
            <span class="page-link" aria-hidden="true">‹</span>
        </li>
        <li class="page-item active" aria-current="page"><span class="page-link">1</span></li>
        <li class="page-item"><a class="page-link" href="http://sic-be.test/admin/website/users?page=2">2</a>
        </li>
        <li class="page-item"><a class="page-link" href="http://sic-be.test/admin/website/users?page=3">3</a>
        </li>
        <li class="page-item">
            <a class="page-link" href="http://sic-be.test/admin/website/users?page=2" rel="next"
               aria-label="Next »">›</a>
        </li>
    </ul>

</template>

<script>
export default {
  name: "LaravelPagination",
  props: ["pagination"]
};
</script>

<style scoped>
</style>
